// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const veluza: PokeData = {
  "id": 976,
  "name": "veluza",
  "height": 25,
  "weight": 900,
  "base_experience": 167,
  "types": [
    PokeType.WATER,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "focus-energy",
    "slash",
    "crunch",
    "water-pulse",
    "pluck",
    "night-slash",
    "psycho-cut",
    "aqua-jet",
    "final-gambit",
    "liquidation",
    "fillet-away",
    "aqua-cutter"
  ],
  "moves": [
    "tackle",
    "crunch",
    "night-slash",
    "aqua-jet",
    "liquidation",
    "aqua-cutter",
    "rain-dance",
    "reflect",
    "psywave",
    "psychic",
    "calm-mind",
    "water-spout",
    "psychic-terrain"
  ],
  "evolution_chain": {
    "id": 512,
    "item": null,
    "species": [
      {
        "name": "veluza",
        "order": 932,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 126,
    "speed": 111,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 100,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
